import { render } from "./DetailTransaction.vue?vue&type=template&id=4b38f92e&scoped=true"
import script from "./DetailTransaction.vue?vue&type=script&lang=js"
export * from "./DetailTransaction.vue?vue&type=script&lang=js"

import "./DetailTransaction.vue?vue&type=style&index=0&id=4b38f92e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b38f92e"]])

export default __exports__